import { useState } from 'react';
import { CreateJobRequest, Job } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

interface UseCreateJobResult {
  createJob: (data: CreateJobRequest) => Promise<Job>;
  isLoading: boolean;
  error: Error | null;
}

export function useCreateJob(): UseCreateJobResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const createJob = async (data: CreateJobRequest): Promise<Job> => {
    try {
      setIsLoading(true);
      setError(null);
      
      const job = await apiClient.post<Job>('/jobs', data);
      return job;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to create job');
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createJob,
    isLoading,
    error,
  };
}
